import script from "./Credentials.vue?vue&type=script&setup=true&lang=js"
export * from "./Credentials.vue?vue&type=script&setup=true&lang=js"

import "./Credentials.vue?vue&type=style&index=0&id=3526faae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3526faae"]])

export default __exports__